import { Button } from "antd";
import useCreate from "hooks/useCreate";
import { PlusOutlined } from "@ant-design/icons";
import { useMemo } from "react";

const CreateNextSubIssue = ({
  client_phone,
  issue_group_id,
  sub_issues,
  refetch,
}) => {
  const client_apartment_number = useMemo(() => {
    const numbers = sub_issues
      .map((i) => i.client_apartment_number)
      .filter(Boolean)
      .map((v) => parseInt(v.match(/\d+/)?.[0] ?? "", 10))
      .filter(Number.isFinite);

    return numbers.length > 0 ? Math.max(...numbers) + 1 : 1;
  }, [sub_issues]);

  const { is_saving, create } = useCreate({
    path: `/issue_groups/${issue_group_id}/generate_sub_issue`,
    onSuccess: refetch,
    success_message: `Dodano podzgłoszenie o numerze mieszkania "${client_apartment_number}"`,
  });

  return (
    <Button
      loading={is_saving}
      type="primary"
      onClick={() => create({ client_apartment_number, client_phone })}
      icon={<PlusOutlined />}
    />
  );
};

export default CreateNextSubIssue;
